import {
    DEALERADDEDITUSERMASTER_SUCCESS,
    DEALERADDEDITUSERMASTER_FAILED,
    RESET_DEALERADDEDITUSERMASTER,
    LOADING_DEALERADDEDITUSERMASTER,
    NETWORK_ERROR_DEALERADDEDITUSERMASTER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERADDEDITUSERMASTER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERADDEDITUSERMASTER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERADDEDITUSERMASTER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERADDEDITUSERMASTER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERADDEDITUSERMASTER:
            return (state = initialState);
        default:
            return state;
    }
};
